<template>
  <layout-content>
    <div :class="`dashboard-card dashboard-card--${icon}`">
      <div class="dashboard-card__title-row">
        <img class="dashboard-card__img" :src="`/img/dashboard/${icon}.svg`" alt="Zorra" />
        <h6 class="dashboard-card__title">{{ $t(title_connect) }}</h6>
        <i-button
          v-if="is_action"
          class="dashboard-card__button"
          type="primary"
          size="large"
          :loading="loading"
          @click="action"
        >
          {{ $t(button_title_connect) }}
        </i-button>
        <i-button v-else class="dashboard-card__button" type="primary" size="large">
          {{ $t(button_title) }}
        </i-button>
      </div>
      <p class="dashboard-card__body">
        {{ $t(description) }}
      </p>
    </div>
  </layout-content>
</template>

<script>
  import { ModulesService } from '@core/services/ModulesService';
  import { mapActions } from 'vuex';

  export default {
    data: () => ({
      loading: false,
      icon: 'data-base',
      title: 'core.dashboard.data-base.title',
      title_connect: 'core.dashboard.data-base.title2',
      description: 'core.dashboard.data-base.description',
      is_action: true,
      button_title_connect: 'core.dashboard.data-base.button2',
      is_additional: true
    }),

    methods: {
      ...mapActions('core/auth', ['syncFullProfile']),

      action() {
        this.loading = true;
        ModulesService.updateStatus(this.$user.id, { module_predictive_is_allowed: true })
          .then((response) => {
            if (response.success) {
              this.$noty.success(this.$t('core.dashboard.noty.connect-autocaller'));
              this.loading = false;
              setTimeout(() => {
                window.location.href = '/predictive';
              }, 1000);

            } else {
              this.$noty.server_error();
            }
          })
          .catch((error) => this.$noty.server_error(error));
      }
    }
  };
</script>
